import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import StatsSection from "../components/StatsSection";
import ProductsSection from "../components/ProductsSection";
import CartDrawer from "../components/CartDrawer";

const Home = () => {
  return (
    <PageWrapper>
      <GlobalHalo />
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ProductsSection />
      <CartDrawer />
    </PageWrapper>
  );
};

export default Home;

const PageWrapper = styled.div`
  background-color: var(--bg);
  min-height: 100vh;
  overflow-x: hidden;
`;

const GlobalHalo = styled.div`
  position: fixed;
  top: -180px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 120vh;
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    rgba(139, 58, 26, 0.35) 0%,
    rgba(139, 58, 26, 0.15) 45%,
    transparent 70%
  );
  filter: blur(60px);
  z-index: 0;
  pointer-events: none;
`;
